import { render, staticRenderFns } from "./Leprechaun.vue?vue&type=template&id=6210c380&"
import script from "./Leprechaun.vue?vue&type=script&lang=js&"
export * from "./Leprechaun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports